import {
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Spin,
  Tag,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useNavigation, useParams } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import InputField from "../../../common/htmlComponents/InputField";
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import logo from "../../../image/PROCEM.svg";
import {
  CloseOutlined,
  DollarOutlined,
  PlusSquareOutlined,
  TagOutlined,
} from "@ant-design/icons";
import AddNewClient from "../performa/AddNewClient";
import { getRequest, patchRequest, postRequest } from "../../../axios"; // Assuming postRequest for form submit
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import { authUserData } from "../../../utils/Helper";
import { Option } from "antd/lib/mentions";

const CommercialInvoice = () => {
  const { t } = useTranslation();
  const hasPermission = authUserData()?.role[0].name;

  const [form] = Form.useForm(); // Antd Form instance
  const [state, setState] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reload, setReload] = useState(false);
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, settotalCount] = useState(0);
  const [rate, setRate] = useState(0);
  const [amount, setAmount] = useState(0);
  const [companyOnboarding, setCompanyOnboarding] = useState([]);
  const [totalInWords, setTotalInWords] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [resetForm, setResetForm] = useState(false);
  // const [sgstAmount, setSgstAmount] = useState(0);
  // const [cgstAmount, setCgstAmount] = useState(0);

  const navigate = useNavigate();

  const { id } = useParams();
  const ID = id ? atob(id) : null;
  

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setState({});
    form.resetFields();
  };


  useEffect(() => {
    getSubscriptionList();
  
    if (ID !== null) {
      getCompanyList();
    } else {
      setState((prev) => ({
        ...prev,
        billed_by_name: "IKSHANA AUTOMATION PRIVATE LIMITED",
        billed_by_mobile: "+91 9714174440",
        billed_by_email: "support@ikshanaautomation.com",
        billed_by_address: "Ganesh, Glory, Jagatpur, Gujarat, Ahmedabad, 380006",
        billed_by_gst_number: "24AAHCI9193A1ZL",
      }));
  
      form.setFieldsValue({
        billedByName: "IKSHANA AUTOMATION PRIVATE LIMITED",
        billedByMobile: "+91 9714174440",
        billedByEmail: "support@ikshanaautomation.com",
        billedByAddress: "Ganesh, Glory, Jagatpur, Gujarat, Ahmedabad, 380006",
        billedByGstNumber: "24AAHCI9193A1ZL",
      });
    }
  
    getCompanyOnboardingList();
    setResetForm(false);
  }, [reload]);


  const getSubscriptionList = async () => {
    setLoading(true);
    try {
      const apiResponse = await getRequest(`subscription/`, {});
      if (apiResponse.data.results.success) {
        setSubscriptionList(apiResponse.data.results.data);
        settotalCount(apiResponse.data.count);
      } else {
        ErrorNotificationMsg(t("error_in_subscription_list"));
      }
    } catch (error) {
      console.error("Fetch subscription error", error);
    } finally {
      setLoading(false);
    }
  };

  const getCompanyOnboardingList = async () => {
    setLoading(true);
    try {
      const apiResponse = await getRequest(`company/`, {});
      if (apiResponse.data.results.success) {
        setCompanyOnboarding(apiResponse.data.results.data);
        settotalCount(apiResponse.data.count);
      } else {
        ErrorNotificationMsg(t("error_in_company_onboarding_list"));
      }
    } catch (error) {
      console.error("Fetch company error", error);
    } finally {
      setLoading(false);
    }
  };

  const getCompanyList = async () => {
    setLoading(true);
    try {
      const apiResponse = await getRequest(`commercial-invoice/${ID}`, {});

      if (apiResponse && apiResponse.data) {
        const { data } = apiResponse;
        const { sgstAmount, cgstAmount, grandTotal, sgstRate, cgstRate } =
          calculateTaxes(data.amount, data.rate);
        setRate(data.rate);
        setState(data);
        form.setFieldsValue({
          billedByName: data.billed_by_name,
          billedByMobile: data.billed_by_mobile,
          billedByEmail: data.billed_by_email,
          billedByAddress: data.billed_by_address,
          billedByGstNumber: data.billed_by_gst_number,
          billedto: data.billed_to,
          subscription_package: data.subscription_package_name,
          invoice_number: data.invoice_number,
          invoice_date: moment(data.invoice_date),
          due_date: moment(data.due_date),
          rate: data.rate,
          amount: data.amount,
          sgstRate: data.sgst_rate,
          cgstRate: data.cgst_rate,
          sgst_amount: sgstAmount,
          cgst_amount: cgstAmount,
          totalTaxAmount: data.total_tax_amount,
          grandTotal: data.grand_total,
          gst_number: data.gst_number,
          note: data.note || "",
        });
        // const calculatedSgst = (data.rate / 2).toFixed(2);
        // const calculatedCgst = (data.rate / 2).toFixed(2);
        // const calculatedSgstAmount = (data.amount * calculatedSgst) / 100;
        // const calculatedCgstAmount = (data.amount * calculatedCgst) / 100;
        // Update state for SGST and CGST amounts
        // setSgstAmount(calculatedSgstAmount);
        // setCgstAmount(calculatedCgstAmount);
      } else {
        notification.error({ message: "Error fetching invoice data" });
      }
    } catch (error) {
      console.error("Fetch company error", error);
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    if (state?.billed_to && companyOnboarding.length > 0) {
      form.setFieldsValue({ billedto: state.billed_to });
    }
  }, [companyOnboarding, state?.billed_to]);

  // Handle text input change
  const handleInputChange = (name, value) => {
    setState((prev) => ({ ...prev, [name]: value }));
    form.setFieldsValue({ [name]: value });
  };

  // Handle Datepicker
  const handleDatepickerChange = (date, dateString, name) => {
    setState((prev) => ({ ...prev, [name]: dateString }));
  };

  const handleSelectChange = (name, value) => {
    setState((prev) => ({ ...prev, [name]: value }));
    form.setFieldsValue({ [name]: value });
  };

  // const handleAmountChange = (value) => {
  //   const numericValue = parseFloat(value) || 0;
  //   console.log('valuecxz', value);

  //   setAmount(numericValue);
  //   setState((prev) => ({ ...prev, amount: numericValue }));
  //   form.setFieldsValue({ amount: numericValue }); // Update form fields

  //   // const calculatedSgst = (data.rate / 2).toFixed(2);
  //   // const calculatedCgst = (data.rate / 2).toFixed(2);
  //   // const calculatedSgstAmount = (data.amount * calculatedSgst) / 100;
  //   // const calculatedCgstAmount = (data.amount * calculatedCgst) / 100;
  //   // Update state for SGST and CGST amounts
  //   // setSgstAmount(calculatedSgstAmount);
  //   // setCgstAmount(calculatedCgstAmount);
  // };

  const handleAmountChange = (value) => {
    const numericValue = parseFloat(value) || 0;
    setState((prev) => {
      const { sgstRate, cgstRate, sgstAmount, cgstAmount, grandTotal } =
        calculateTaxes(numericValue, prev.rate);
      return {
        ...prev,
        amount: numericValue,
        sgst_rate: sgstRate,
        cgst_rate: cgstRate,
        sgst_amount: sgstAmount,
        cgst_amount: cgstAmount,
        grand_total: grandTotal,
      };
    });
  };

  const handleRateChange = (value) => {
    const numericValue = parseFloat(value) || 0;
    setRate(numericValue);
    setState((prev) => {
      const { sgstRate, cgstRate, sgstAmount, cgstAmount, grandTotal } =
        calculateTaxes(prev.amount, numericValue);
      return {
        ...prev,
        rate: numericValue,
        sgst_rate: sgstRate,
        cgst_rate: cgstRate,
        sgst_amount: sgstAmount,
        cgst_amount: cgstAmount,
        grand_total: grandTotal,
      };
    });
    form.setFieldsValue({ rate: numericValue });
  };

  const sgst = (rate / 2).toFixed(2);
  const cgst = (rate / 2).toFixed(2);

  const calculateTaxes = (amount, rate) => {
    const sgstRate = rate / 2;
    const cgstRate = rate / 2;
    const sgstAmount = parseFloat(((state.amount * sgstRate) / 100).toFixed(2));
    const cgstAmount = parseFloat(((state.amount * cgstRate) / 100).toFixed(2));
    const grandTotal = amount + sgstAmount + cgstAmount;
    return { sgstRate, cgstRate, sgstAmount, cgstAmount, grandTotal };
  };

  const { sgstAmount, cgstAmount } = calculateTaxes(amount, rate);

  const handleSubmit = async (values) => {
    const baseAmount = parseFloat(values.amount);
    const sgstAmt = parseFloat(sgstAmount.toFixed(2));
    const cgstAmt = parseFloat(cgstAmount.toFixed(2));
    const totalTax = sgstAmt + cgstAmt;
    const grandTotal = baseAmount + totalTax;

    const payload = {
      ...state,
      billed_by_name: state.billed_by_name,
      billed_by_mobile: state.billed_by_mobile,
      billed_by_email: state.billed_by_email,
      billed_by_address: state.billed_by_address,
      billed_by_gst_number: state.billed_by_gst_number,
      billed_to: state.billedto,
      billed_to_name: state.billed_to_name,
      subscription_package: state.subscription_package,
      subscription_package_name: state.subscription_package_name,
      invoice_number: values.invoice_number,
      invoice_date: values.invoice_date?.format("YYYY-MM-DD"),
      due_date: values.due_date?.format("YYYY-MM-DD"),
      rate: state.rate,
      amount: state.amount,
      sgst_rate: sgst,
      cgst_rate: cgst,
      sgst_amount: sgstAmount,
      cgst_amount: cgstAmount,
      total_tax_amount: totalTax,
      grand_total: parseFloat(grandTotal.toFixed(2)),
      gst_number: state.gst_number,
      note: state.note,
      billedto: state.billedto,
    };

    if (ID) {
      try {
        setLoading(true);
        const apiResponse = await patchRequest(
          `commercial-invoice/${ID}/`,
          payload
        );

        if (apiResponse.status === 200) {
          SuccessNotificationMsg(t("Invoice Created Successfully"));
          form.resetFields();
          setState({});
          // setReload(!reload);
          navigate("/commercial-invoice");
          setLoading(false);
        } else {
          ErrorNotificationMsg(t("Error In Creating Invoice"));
        }
        
      } catch (error) {
        console.error("Invoice create error", error);
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        const apiResponse = await postRequest("commercial-invoice/", payload);
        
        if (apiResponse.status === 201) {
          SuccessNotificationMsg(t("Invoice Created Successfully"));
          form.resetFields();
          setState({});
          // setReload(!reload);
          navigate("/commercial-invoice");
          setLoading(false);
        } else {
          ErrorNotificationMsg(t("Error In Creating Invoice"));
          setLoading(false);
        }
      } catch (error) {
        console.error("Invoice create error", error);
        setLoading(false);
      }
    }
  };

  // const numberToWords = (num) => {
  //   if (num === undefined || num === null) return "Zero";
  //   const ones = [
  //     "",
  //     "One",
  //     "Two",
  //     "Three",
  //     "Four",
  //     "Five",
  //     "Six",
  //     "Seven",
  //     "Eight",
  //     "Nine",
  //     "Ten",
  //     "Eleven",
  //     "Twelve",
  //     "Thirteen",
  //     "Fourteen",
  //     "Fifteen",
  //     "Sixteen",
  //     "Seventeen",
  //     "Eighteen",
  //     "Nineteen",
  //   ];
  //   const tens = [
  //     "",
  //     "",
  //     "Twenty",
  //     "Thirty",
  //     "Forty",
  //     "Fifty",
  //     "Sixty",
  //     "Seventy",
  //     "Eighty",
  //     "Ninety",
  //   ];
  //   const thousands = ["", "Hundred", "Thousand", "Lakh", "Crore"];

  //   if (num === 0) return "Zero";

  //   let result = "";
  //   let i = 0;

  //   // Convert the integer part of the number
  //   let integerPart = Math.floor(num);
  //   while (integerPart > 0) {
  //     if (integerPart % 1000 !== 0) {
  //       result = `${convertHundreds(integerPart % 1000)} ${thousands[i]} ${result}`;
  //     }
  //     integerPart = Math.floor(integerPart / 1000);
  //     i++;
  //   }

  //   // If there is a decimal part, handle it
  //   const decimalPart = num % 1;
  //   if (decimalPart > 0) {
  //     const decimalString = decimalPart.toFixed(2).split(".")[1]; // Get the decimal part (e.g., 25 from 0.25)
  //     result += ` Point ${convertDecimal(decimalString)}`;
  //   }

  //   return result.trim();
  // };

  // // Convert the decimal part (for example, 25 -> twenty-five)
  // const convertDecimal = (decimal) => {
  //   const ones = [
  //     "",
  //     "One",
  //     "Two",
  //     "Three",
  //     "Four",
  //     "Five",
  //     "Six",
  //     "Seven",
  //     "Eight",
  //     "Nine",
  //     "Ten",
  //     "Eleven",
  //     "Twelve",
  //     "Thirteen",
  //     "Fourteen",
  //     "Fifteen",
  //     "Sixteen",
  //     "Seventeen",
  //     "Eighteen",
  //     "Nineteen",
  //     "Twenty",
  //     "Thirty",
  //     "Forty",
  //     "Fifty",
  //     "Sixty",
  //     "Seventy",
  //     "Eighty",
  //     "Ninety",
  //   ];

  //   let result = "";
  //   for (let i = 0; i < decimal.length; i++) {
  //     const num = parseInt(decimal[i]);
  //     result += ones[num] + " ";
  //   }
  //   return result.trim();
  // };

  // const convertHundreds = (num) => {
  //   const ones = [
  //     "",
  //     "One",
  //     "Two",
  //     "Three",
  //     "Four",
  //     "Five",
  //     "Six",
  //     "Seven",
  //     "Eight",
  //     "Nine",
  //     "Ten",
  //     "Eleven",
  //     "Twelve",
  //     "Thirteen",
  //     "Fourteen",
  //     "Fifteen",
  //     "Sixteen",
  //     "Seventeen",
  //     "Eighteen",
  //     "Nineteen",
  //   ];
  //   const tens = [
  //     "",
  //     "",
  //     "Twenty",
  //     "Thirty",
  //     "Forty",
  //     "Fifty",
  //     "Sixty",
  //     "Seventy",
  //     "Eighty",
  //     "Ninety",
  //   ];

  //   let result = "";

  //   if (num > 99) {
  //     result += ones[Math.floor(num / 100)] + " Hundred ";
  //     num = num % 100;
  //   }

  //   if (num > 19) {
  //     result += tens[Math.floor(num / 10)] + " ";
  //     num = num % 10;
  //   }

  //   if (num > 0) {
  //     result += ones[num] + " ";
  //   }

  //   return result.trim();
  // };

  const numberToWords = (num) => {
    if (num === undefined || num === null || isNaN(num))
      return "Zero Rupees Only";

    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const convertTwoDigits = (n) => {
      if (n < 20) return ones[n];
      return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
    };

    const convertThreeDigits = (n) => {
      let word = "";
      if (Math.floor(n / 100) > 0) {
        word += ones[Math.floor(n / 100)] + " Hundred ";
      }
      if (n % 100 > 0) {
        word += convertTwoDigits(n % 100);
      }
      return word.trim();
    };

    const convertIndianNumber = (n) => {
      let word = "";

      const crore = Math.floor(n / 10000000);
      n %= 10000000;
      const lakh = Math.floor(n / 100000);
      n %= 100000;
      const thousand = Math.floor(n / 1000);
      n %= 1000;
      const hundred = n;

      if (crore > 0) word += convertTwoDigits(crore) + " Crore ";
      if (lakh > 0) word += convertTwoDigits(lakh) + " Lakh ";
      if (thousand > 0) word += convertTwoDigits(thousand) + " Thousand ";
      if (hundred > 0) word += convertThreeDigits(hundred);

      return word.trim();
    };

    const integerPart = Math.floor(num);
    const decimalPart = Math.round((num - integerPart) * 100);

    let result = convertIndianNumber(integerPart) + " Rupees";
    if (decimalPart > 0) {
      result += " and " + convertTwoDigits(decimalPart) + " Paise";
    }

    return result + " Only";
  };

  useEffect(() => {
    const total = state.grand_total;
    setTotalInWords(numberToWords(total));
  }, [state]);

  useEffect(() => {
    const generateInvoiceNumber = () => {
      const newInvoiceNumber = `INV-${Date.now()}`;
      setInvoiceNumber(newInvoiceNumber);
      form.setFieldsValue({ invoice_number: newInvoiceNumber });
    };
    generateInvoiceNumber();
  }, []);

  const capitalizeWords = (str) =>
    str.replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <>
    {/* <Spin spinning={loading}> */}
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Commercial Invoice</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Commercial Invoice</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      <section className="grid-sec FormSection Container InvoiceSec">
        <div className="FormBody">
          
            
<Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            autoComplete="off"
            initialValues={{
              invoice_number: invoiceNumber,
            }} className="stepscontentwrap" style={{ padding: 0 }}
          >
            <div className="stepsContent">
            {/* Top Line: Logo + Invoice Info */}
            <div
              className="InvoiceTopLine"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "24px",
              }}
            >
              {/* Logo */}
              <div className="LogoWrap">
                <img src={logo} alt="Company Logo" style={{ height: "40px" }} />
              </div>

              {/* Invoice Info Fields */}
              <div
                className="InvoiceFields"
                style={{ display: "flex", gap: "16px" }}
              >
                <Form.Item
                  name="invoice_number"
                  label="Invoice Number"
                  style={{ marginBottom: 0 }}
                >
                  <Input
                    value={invoiceNumber}
                    placeholder="Invoice Number"
                    disabled={true}
                  />
                </Form.Item>

                <Form.Item
                  name="invoice_date"
                  label="Invoice Date"
                  style={{ marginBottom: 0 }}
                >
                  <DatePicker format="DD-MM-YYYY" />
                </Form.Item>

                <Form.Item
                  name="due_date"
                  label="Due Date"
                  style={{ marginBottom: 0 }}
                >
                  <DatePicker format="DD-MM-YYYY" />
                </Form.Item>
              </div>
            </div>

            <Row gutter={16}>
              {/* Billed By */}
              <Col span={12}>
                <Card
                  style={{
                    background: "#fafafa",
                    borderRadius: "8px",
                    minHeight: "250px",
                  }}
                >
                  <h3 style={{ marginBottom: "16px" }}>{t("pl_billed_by")}</h3>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      fontSize: "14px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span>
                        <b>Name:</b>
                        {state.billed_by_name}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span>
                        <b>Mobile:</b>
                        {state.billed_by_mobile}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span>
                        <b>Email:</b> {state.billed_by_email}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span>
                        <b>Address:</b> {state.billed_by_address}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span>
                        <b>GSTN:</b>
                        {state.billed_by_gst_number}
                      </span>
                    </div>
                  </div>
                </Card>
              </Col>

              {/* Billed To */}
              <Col span={12}>
                <Card
                  style={{
                    background: "#fafafa",
                    borderRadius: "8px",
                    minHeight: "250px",
                    alignContent:"center"
                  }}
                >
                  <h3 style={{ marginBottom: "16px" }}>{t("pl_billed_to")}</h3>

                  <Form.Item
                    name="billedto"
                    label=""
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_enter_address")}</Trans>,
                      },
                    ]}
                    style={{ alignContent:'center'}}
                  >
                    <Select
                      placeholder={t("pl_select_client")}
                      loading={loading}
                      showSearch
                      showArrow
                      onChange={(value) =>
                        handleSelectChange("billedto", value)
                      }
                      style={{
                        width: "100%",
                        border: "1px solid #d9d9d9", 
                        borderRadius: "6px",
                        alignContent:'center',
                        lineHeight:"0px"
                      }}
                    >
                      {companyOnboarding.map((company) => (
                        <Option key={company.id} value={company.id} style={{ alignContent:'center'}}>
                          {capitalizeWords(company.name)}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <div style={{ textAlign: "center", marginTop: "12px" }}>
                    <span style={{ color: "#888" }}>OR</span>
                    <div style={{ marginTop: "8px" }}>
                      <Button
                        type="dashed"
                        icon={<PlusSquareOutlined />}
                        onClick={showModal}
                        style={{ width: "220px" }}
                      >
                        Add New Company
                      </Button>
                    </div>
                  </div>

                  <Modal
                    title={
                      <div
                        style={{
                          color: "#094E8F",
                          fontWeight: "600",
                          fontSize: "20px",
                        }}
                      >
                        Add Company
                      </div>
                    }
                    open={isModalOpen}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    closable={false}
                    wrapClassName="modal-wrapper"
                    width="80vw"
                    style={{ textAlign: "center" }}
                  >
                    <AddNewClient
                      handleCancel={handleCancel}
                      setIsModalOpen={setIsModalOpen}
                      isModalOpen={isModalOpen}
                      getCompanyOnboardingList={getCompanyOnboardingList}
                      setReload={setReload}
                      resetForm={resetForm}
                      setResetForm={setResetForm}
                      reload={reload}
                    />
                  </Modal>
                </Card>
              </Col>
            </Row>

            <Card
              style={{
                marginTop: "24px",
                background: "#fafafa",
                borderRadius: "8px",
              }}
            >
              <h3 style={{ marginBottom: "16px" }}>Invoice Items</h3>
              <Row gutter={16}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="subscription_package"
                    label="Subscription Package"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_subscription_package")}</Trans>,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("pl_subscription_package")}
                      loading={loading}
                      onChange={(value) =>
                        handleSelectChange("subscription_package", value)
                      }
                    >
                      {subscriptionList.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.package_name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="rate"
                    label="GST"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_rate")}</Trans>,
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder={t("pl_rate")}
                      onChange={(e) => handleRateChange(e.target.value)}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="gst_number"
                    label="GST Number"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_gst_number")}</Trans>,
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("pl_enter_gst_number")}
                      onChange={(e) =>
                        handleInputChange("gst_number", e.target.value)
                      }
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="amount"
                    label="Amount"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the amount",
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder="Enter amount"
                      value={state.amount}
                      onChange={(e) => handleAmountChange(e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="note" label={t("pl_note")}>
                    <TextArea rows={2} placeholder="Add a note..." />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            {/* Taxes and Notes */}
            <Row gutter={16} justify="start">
              <Col xs={24} sm={12} md={8}>
                <Card bordered={false} className="invoice-tax-card">
                  <div className="tax-row">
                    <Tag icon={<TagOutlined />} color="blue">
                      SGST {state.sgst_rate || 0} %
                    </Tag>
                    <span style={{ float: "right" }}>
                      ₹ {state.sgst_amount?.toFixed(2) || 0.00}
                    </span>
                  </div>

                  <div className="tax-row">
                    <Tag icon={<TagOutlined />} color="green" name="cgstRate">
                      CGST {state.cgst_rate || 0 } %
                    </Tag>
                    <span style={{ float: "right" }}>
                      ₹ {state.cgst_amount?.toFixed(2) || 0}
                    </span>
                  </div>

                  <div className="tax-row" style={{ fontWeight: "bold" }}>
                    <Tag icon={<TagOutlined />} color="gold">
                      Total
                    </Tag>
                    <span style={{ float: "right" }}>
                      ₹ {state.grand_total?.toFixed(2) || 0}
                    </span>
                  </div>

                  <div className="tax-row" style={{ marginTop: "10px" }}>
                    {/* Display the total in words directly */}
                    {totalInWords && (
                      <div
                        style={{
                          marginTop: "12px",
                          fontSize: "16px",
                          color: "#1890ff",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <strong>Total in words:</strong> {totalInWords}
                      </div>
                    )}
                  </div>
                </Card>
              </Col>
            </Row>
            </div>
            {/* Submit button */}
            <div className="FormFooter">
              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="submit"
                label={t("Save")}
                loading={loading}
              />
            </div>
          </Form>
        
          
        </div>
      </section>
      {/* </Spin> */}
    </>
  );
};

export default CommercialInvoice;
